/**
 * InkyPic Image Preview Component
 * Displays before/after comparison of original and colorized images
 */

import React from 'react';
import '../styles/ImagePreview.css';

const ImagePreview = ({ originalImage, colorizedImageUrl, onReset, onDownload }) => {
  return (
    <div className="preview-container">
      <h2 className="preview-title">✨ Your Colorized Image</h2>

      <div className="images-comparison">
        <div className="image-box">
          <h3 className="image-label">Original</h3>
          <img
            src={originalImage}
            alt="Original black and white"
            className="preview-image"
          />
        </div>

        <div className="comparison-arrow">→</div>

        <div className="image-box">
          <h3 className="image-label">Colorized</h3>
          <img
            src={colorizedImageUrl}
            alt="Colorized"
            className="preview-image"
          />
        </div>
      </div>

      <div className="preview-actions">
        <button className="action-button download-button" onClick={onDownload}>
          <span className="button-icon">⬇</span>
          Download Colorized Image
        </button>
        <button className="action-button reset-button" onClick={onReset}>
          <span className="button-icon">🔄</span>
          Colorize Another Image
        </button>
      </div>
    </div>
  );
};

export default ImagePreview;
